import React from 'react';
import { FaFilter,FaFileInvoice,FaFileExport } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const FilterSection = ({ filter, setFilter, navigate,exportToCSV }) => {
  return (
    <div className="card mb-4 shadow-sm">
      <div className="card-header bg-primary text-white">
        <h5 className="mb-0">
          <FaFilter className="me-2" />
          Filter Options
        </h5>
      </div>
      <div className="card-body">
        <div className="row">
                 
          <div className="col-md-4 mb-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="monthRangeCheck"
                checked={filter.monthRange}
                onChange={(e) => setFilter({
                  ...filter,
                  monthRange: e.target.checked,
                  dateRange: e.target.checked ? false : filter.dateRange
                })}
              />
             <p className="form-check-label" htmlFor="monthRangeCheck">
                Payment Month Range
              </p>
            </div>
            
            {filter.monthRange && (
              <div className="row mt-2 g-2">
                <div className="col-md-6">
                 <p className="form-label small">Start Month</p>
                  <DatePicker
                    selected={filter.startMonth}
                    onChange={(date) => setFilter({...filter, startMonth: date})}
                    dateFormat="MM/yyyy"
                    showMonthYearPicker
                    className="form-control"
                  />
                </div>
                <div className="col-md-6">
                 <p className="form-label small">End Month</p>
                  <DatePicker
                    selected={filter.endMonth}
                    onChange={(date) => setFilter({...filter, endMonth: date})}
                    dateFormat="MM/yyyy"
                    showMonthYearPicker
                    className="form-control"
                  />
                </div>
              </div>
            )}
          </div>
          
          <div className="col-md-4 mb-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="dateRangeCheck"
                checked={filter.dateRange}
                onChange={(e) => setFilter({
                  ...filter,
                  dateRange: e.target.checked,
                  monthRange: e.target.checked ? false : filter.monthRange
                })}
              />
             <p className="form-check-label" htmlFor="dateRangeCheck">
                Payment Date Range
              </p>
            </div>
            
            {filter.dateRange && (
              <div className="row mt-2 g-2">
                <div className="col-md-6">
                 <p className="form-label small">Start Date</p>
                  <DatePicker
                    selected={filter.startDate}
                    onChange={(date) => setFilter({...filter, startDate: date})}
                    selectsStart
                    startDate={filter.startDate}
                    endDate={filter.endDate}
                    className="form-control"
                  />
                </div>
                <div className="col-md-6">
                 <p className="form-label small">End Date</p>
                  <DatePicker
                    selected={filter.endDate}
                    onChange={(date) => setFilter({...filter, endDate: date})}
                    selectsEnd
                    startDate={filter.startDate}
                    endDate={filter.endDate}
                    minDate={filter.startDate}
                    className="form-control"
                  />
                </div>
              </div>
            )}
          </div>
          
          <div className="col-md-4 d-flex justify-content-end float-end  mb-3">
            <button 
              className="btn btn-warning text-white me-2" style={{height:"fit-content"}}
              onClick={() => navigate('/ledger-reports')}
            >
              <FaFileInvoice className="me-2" />
              View Reports
            </button>
            {/* <button 
              className="btn btn-success"
              onClick={exportToCSV}
            >
              <FaFileExport className="me-2" />
              Export CSV
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSection;